import React from "react";

import { useTranslation } from "react-i18next";

import { HomeAwayScore } from "@gp/models";
import { observer } from "mobx-react";

export const OvertimeScore = observer(function OvertimeScore(props: {
	overTimeScore: HomeAwayScore;
}) {
	const { t } = useTranslation();

	return (
		<div className="event__stats__item">
			<div className="event__stats__label">{t("EVENT.DETAILS.OT")}</div>
			<div className="event__stats__result">
				<span>{props.overTimeScore.home || 0}</span>
				<span> - </span>
				<span>{props.overTimeScore.away || 0}</span>
			</div>
		</div>
	);
});
